import { DocketwiseActions } from './partials/docketwise'
import { ECOMemberPassIntegrationActions } from './partials/eco-member-pass'
import { ECOPortalIntegrationActions } from './partials/eco-portal'
import { OWRIntegrationActions } from './partials/owr'
import { SignupIntegrationActions } from './partials/signup'
import { TmetricActions } from './partials/tmetric'

export const IntegrationActions = {
  ...DocketwiseActions,
  ...ECOMemberPassIntegrationActions,
  ...ECOPortalIntegrationActions,
  ...OWRIntegrationActions,
  ...SignupIntegrationActions,
  ...TmetricActions,
}
